import dayjs from 'dayjs'

const AUTOCALL_CUSTOMER_CENTER = '1566-7531'
const AUTOCALL_DEPOSITOR_NAME = '오토콜 환불'

export type RefundCompleteContentsParams = {
  isSkt: boolean
  amount: number | undefined
  bank?: string
  account?: string
  name?: string
  RegDT?: string
  extraNote?: string
}

export function getRefundCompleteTitle(isSkt: boolean): string {
  return isSkt ? '환불 접수 완료' : '서비스 해지 및 환불 접수 완료'
}

function formatRefundDisplayDate(RegDT?: string): string {
  return RegDT ? dayjs(RegDT).format('YYYY년 MM월 DD일') : dayjs().format('YYYY년 MM월 DD일')
}

/** SKT / 비SKT 환불 완료 모달 본문 (성공·대기 공통) */
export function getRefundCompleteContents({
  isSkt,
  amount,
  bank,
  account,
  name,
  RegDT,
  extraNote = '',
}: RefundCompleteContentsParams): string {
  const amountText = amount?.toLocaleString() ?? ''
  const bankInfo = `${bank ?? ''}/${account ?? ''}/${name ?? ''}`

  if (isSkt) {
    const displayDate = formatRefundDisplayDate(RegDT)
    return (
      `이용해 주셔서 감사합니다.\n\n` +
      `${displayDate} 환불 접수되었으며 ${amountText}원이 영업일 기준 2일 이내 입금될 예정입니다.\n` +
      `궁금하신 사항은 고객센터 ${AUTOCALL_CUSTOMER_CENTER}로 연락 부탁 드립니다.\n\n` +
      `※ 계좌번호, 예금주 등 입력하신 환불정보에 문제가 있을 경우 환불이 지연될 수 있습니다.\n\n` +
      `입력하신 정보: ${bankInfo}\n` +
      `입금자명: ${AUTOCALL_DEPOSITOR_NAME}` +
      extraNote
    )
  }

  return (
    `이용해 주셔서 감사합니다.\n\n` +
    `${amountText}원이 영업일 7일 이내 입금될 예정입니다.\n` +
    `※ 계좌번호, 예금주 등 입력하신 환불정보에 문제가 있을 경우 환불이 지연될 수 있습니다.\n\n` +
    `입력하신 정보: ${bankInfo}` +
    extraNote
  )
}
